export const SCREEN_NAMES = {
	SYNCED_TRANSACTIONS: "SyncedTransactions",
	RECURRING_TRANSACTIONS: "RecurringTransactions",
} as const;

export type ScreenName = (typeof SCREEN_NAMES)[keyof typeof SCREEN_NAMES];
